const TestKeys = {
  autoPaymentCardIcon: 'AutoPaymentCardIcon',
  autoPaymentCardToggle: 'AutoPaymentCardToggle',
  autoPaymentCardTitleText: 'AutoPaymentCardTitleText',
  autoPaymentCardDescription: 'AutoPaymentCardDescription',
  autoPaymentCardBtn: 'AutoPaymentCardBtn',
  billsError: 'billsError',
  billCardYearText: 'BillCardYearTxt',
  billCardBadge: 'BillCardBadge',
  billCardMonthStatusContainer: 'BillCardMonthStatusContainerView',
  billCardPriceText: 'BillCardPriceText',
  billCardRemainingAmountText: 'BillCardRemainingAmountTxt',
  billCardDescriptionAmountFirstLineText: 'BillCardDescriptionAmountFirstLineTxt',
  billCardDescriptionAmountSecondLineText: 'BillCardDescriptionAmountSecondLineTxt',
  barChartDetailsTimePeriodText: 'BarChartDetailsTimePeriodTxt',
  barChartDetailsBillAmountText: 'BarChartDetailsBillAmountTxt',
  barChartDetailsBtn: 'BarChartDetailsBtn',
  barChartDetailsSeeBillText: 'BarChartDetailsSeeBillTxt',
  barsYearBillDetails: 'BarsYearBillDetails',
  barsPercentageIndicator: 'BarsPercentageIndicator',
  verticalLabelsView: 'VerticalLabels',
  verticalLabelsBillBarBtn: 'VerticalLabelsBillBarBtn',
  verticalLabelBillDetailsShortMonth: 'VerticalLabelBillDetailsShortMonth',
  chartView: 'ChartView',
  currentBillCard: 'CurrentBillCard',
  currentBillCardContainerView: 'CurrentBillCard',
  currentBillYearText: 'CurrentBillYearTxt',
  currentBillNegativeBalanceView: 'CurrentBillNegativeBalanceView',
  currentBillNegativeBalanceText: 'CurrentBillNegativeBalanceTxt',
  currentBillNegativeIcon: 'currentBillNegativeIcon',
  currentBillMonthText: 'CurrentBillMonthTxt',
  currentBillCurrencyText: 'CurrentBillCurrencyTxt',
  currentBillPriceText: 'CurrentBillPriceTxt',
  currentBillPriceTextFixed: 'CurrentBillPriceTxt',
  currentBillExtraChargesText: 'CurrentBillExtraChargesTxt',
  expansionPanelBreakdownTotalLabelText: 'ExpansionPanelBreakdownTotalLabelTxt',
  expansionPanelBreakdownTotalValueText: 'ExpansionPanelBreakdownTotalValueTxt',
  expansionPanelTotalBeforeVatLabelText: 'ExpansionPanelTotalBeforeVatLabelTxt',
  expansionPanelTotalBeforeVatValueText: 'ExpansionPanelTotalBeforeVatValueTxt',
  expansionPanelTotalWithVatLabelText: 'ExpansionPanelTotalWithVatLabelTxt',
  expansionPanelTotalWithVatValueText: 'ExpansionPanelTotalWithVatValueTxt',
  expansionPanelVatValueText: 'ExpansionPanelVatValueTxt',
  expansionPanelVatLabelText: 'ExpansionPanelVatLabelTxt',
  billDetailsBreakdownHeadlineIcon: 'BillDetailsBreakdownHeadlineIcon',
  billDetailsBreakdownHeadlineTitleText: 'BillDetailsBreakdownHeadlineTitleTxt',
  billDetailsBreakdownHeadlineSubtitleText: 'BillDetailsBreakdownHeadlineSubtitleTxt',
  billImageListServicesDetails: 'BillImageListServicesDetails',
  billImageListServicesIcon: 'BillImageListServicesIcon',
  billImageListServicesArrowIcon: 'BillImageListServicesArrowIcon',
  noBillsTitleText: 'TitleTestID',
  noBillsSubtitleText: 'DescTestID',
  paymentInfoCardBillDateLabelText: 'PaymentInfoCardBillDateLabelText',
  paymentInfoCardBillDateValueText: 'PaymentInfoCardBillDateValueText',
  paymentInfoCardBillNumberLabelText: 'PaymentInfoCardBillNumberLabelText',
  paymentInfoCardBillNumberValueText: 'PaymentInfoCardBillNumberValueText',
  paymentInfoCreditCardBillDateBtn: 'PaymentInfoCreditCardBillDateBtn',
  paymentInfoBillPaidBtn: 'PaymentInfoBillPaidBtn',
  paymentInfoCardDownloadPDFBtn: 'PaymentInfoCardDownloadPDFBtn',
  previousBillSubTitle: 'previousBillSubTitle',
  billDetailsSubscriptionsListShowmoreBtn: 'BillDetailsSubscriptionsListShowmoreBtn',
  billingVFScreenView: 'billingVFScreenView',
  billingBillItem: 'billItem',
  billingBillMonthText: 'month',
  billingBillAmountText: 'amount',
  billingBillCard: 'billCard',
  billingScreenScrollView: 'BillingScreenScrollView',
  billingCurrentBillTitleText: 'BillingCurrentBillTitleText',
  billingCurrentBillToBePaidText: 'BillingCurrentBillToBePaidText',
  billingPreviousBillTitleText: 'BillingPreviousBillTitleText',
  billingShowMoreBtn: 'ShowMoreBtn',
  billingShowMoreBtnText: 'ShowMoreBtnText',
  billingCloseBtn: 'BillingCloseBtn',
  billingScreenTitleText: 'BillingScreenTitleText',
  billCardUnPaidCardDescriptionText: 'BillCardUnPaidCardDescriptionText',
  billCardUnPaidCardDescriptionContainer: 'BillCardUnPaidCardDescriptionContainer',
  billingPaymentBreakdownTitleText: 'BillingPaymentBreakdownTitleText',
  monthlyBillingScreenCloseBtn: 'CloseButtonTestID',
  monthlyBillingScreenBackBtn: 'BackButtonTestID',
  monthlyBillingScreenSubHeaderTitleText: 'SubHeaderTitleText',
  monthlyBillingScreenTitleText: 'TitleText',
  monthlyBillingScreenSubHeaderSubTitleText: 'SubHeaderSubTitleText',
  additionalInfoIconTO: 'additionalInfoIconTO',
  additionalInfoIconView: 'additionalInfoIconView',
  additionalInfoIconIcon: 'additionalInfoIconIcon',
  expansionPanelItemTO: 'expansionPanelItemTO',
  expansionPanelItemView: 'expansionPanelItemView',
  expansionPanelItemBeforeTitleLabelView: 'expansionPanelItemBeforeTitleLabelView',
  expansionPanelItemBeforeTitleLabelText: 'expansionPanelItemBeforeTitleLabelText',
  expansionPanelItemTitleText: 'expansionPanelItemTitleText',
  expansionPanelItemSubtitleText: 'expansionPanelItemSubtitleText',
  expansionPanelItemPriceText: 'expansionPanelItemPriceText',
  expansionPanelItemListView: 'expansionPanelItemListView',
  expansionPanelItemCollapsedListView: 'expansionPanelItemCollapsedListView',
  expansionPanelItemCollapsedListTitleText: 'expansionPanelItemCollapsedListTitleText',
  extraChargesContainer: 'extraChargesContainer',
  extraChargeItemText: 'extraChargeItemText',
  extraChargeItemTextContainer: 'extraChargeItemTextContainer',
  extraChargeItemContainer: 'extraChargeContainer',
  monthlyBillingQAM: 'monthlyBillingQAM',
  monthlyBillingQAMView: 'monthlyBillingQAMView',
  monthlyBillingQAMTitleText: 'monthlyBillingQAMTitleText',
  monthlyBillingQAMCloseBTN: 'monthlyBillingQAMCloseBTN',
  billingScreenNoBillsScrollView: 'billingScreenNoBillsScrollView',
  expansionPanelCard: 'expansionPanelCard',
  negativeBillQAM: 'negativeBillQAM',
  negativeBillQAMTitleView: 'negativeBillQAMTitleView',
  negativeBillQAMTitleText: 'negativeBillQAMTitleText',
  negativeBillQAMDescView: 'negativeBillQAMDescView',
  negativeBillQAMDescText: 'negativeBillQAMDescText',
  negativeBillQAMCloseBTN: 'CloseButtonTestID',
  billCardNegativeBillValueNote: 'billCardNegativeBillValueNote',
  billCardNegativeBillTO: 'billCardNegativeBillTO',
  billCardNegativeBillView: 'billCardNegativeBillView',
  billCardNegativeBillIcon: 'billCardNegativeBillIcon',
  monthlyBillingNegativeBillTO: 'monthlyBillingNegativeBillTO',
  monthlyBillingNegativeBillNoteText: 'NegativeBalanceTestID',
  monthlyBillingNegativeBillView: 'monthlyBillingNegativeBillView',
  monthlyBillingNegativeBillIcon: 'monthlyBillingNegativeBillIcon',
  negativeBillQuickActionTitle: 'negativeBillQuickActionTitle',
  negativeBillQuickActionCloseIcon: 'negativeBillQuickActionCloseIcon',
};

export default Object.seal(TestKeys);
